// extracted by mini-css-extract-plugin
export var auto = "_3u-1";
export var spinner = "_3u-0";